// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HolesPanel_panel__\\+VZMo {
  padding: 20px 30px;
}

.HolesPanel_header__oqIc- {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 10px;
  padding-bottom: 5px;
  border-bottom: 1px solid #f4f5f7;
}

.HolesPanel_title__DffEG {
  font-size: 16.38px;
  font-weight: 600;
  color: #838383;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.HolesPanel_count__ktSCr {
  margin-left: 5px;
  font-weight: 400;
  color: #acacac;
  text-transform: none;
  letter-spacing: 0;
}

.HolesPanel_filters__GYAvH {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
}

.HolesPanel_field__WcnQg {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.HolesPanel_fieldLabel__r5qpI {
  font-size: 9px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #acacac;
}

.HolesPanel_select__3EOfJ {
  padding: 5px 8px;
  font-size: 13px;
  background: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 3px;
  color: #838383;
}
.HolesPanel_select__3EOfJ:focus {
  outline: none;
  border-color: var(--primary-color);
}

.HolesPanel_summary__-PGaR {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  font-size: 12px;
  color: #838383;
  margin-bottom: 5px;
}

.HolesPanel_warn__aA8yx {
  margin: 0 0 5px;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  background: rgba(239, 161, 44, 0.2);
}

.HolesPanel_hint__xxgJd {
  margin: 0 0 5px;
  font-size: 11px;
  color: #acacac;
}

.HolesPanel_empty__ZEU8v {
  color: #acacac;
  font-size: 14px;
  margin: 10px 0;
}

.HolesPanel_loaderWrap__FRLxC {
  display: flex;
  justify-content: center;
  padding: 30px;
}

.HolesPanel_list__Vw32D {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 520px;
  overflow-y: auto;
}

.HolesPanel_row__d5ul9 {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 5px 10px;
  background: none;
  border: none;
  border-bottom: 1px solid #f4f5f7;
  cursor: pointer;
  text-align: left;
  font-size: 13px;
  color: #838383;
}
.HolesPanel_row__d5ul9:hover {
  background: #f4f5f7;
}
.HolesPanel_row__d5ul9 {
  -webkit-user-select: text;
          user-select: text;
  box-sizing: border-box;
}

.HolesPanel_chevron__wthFN {
  font-size: 10px;
  color: #acacac;
  transition: transform 0.15s ease;
}

.HolesPanel_chevronOpen__UDGWK {
  transform: rotate(90deg);
}

.HolesPanel_accordion__e4SmD {
  background: rgba(0, 0, 0, 0.02);
  padding: 10px 20px;
  border-bottom: 1px solid #f4f5f7;
}

.HolesPanel_date__krgmZ {
  font-family: monospace;
  font-weight: 600;
  color: var(--primary-color);
  min-width: 90px;
}

.HolesPanel_centerName__61nWe {
  flex: 1 1;
}

.HolesPanel_ext__Q6pyC {
  color: #acacac;
  font-size: 12px;
}

.HolesPanel_mono__pZT1n {
  font-family: monospace;
  font-size: 12px;
}

.HolesPanel_badge__PGI4L {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: #f4f5f7;
  border: 1px solid #dbdbdb;
  white-space: nowrap;
}

.HolesPanel_kind_both__Nk57l {
  background: rgba(223, 103, 103, 0.15);
  border-color: rgba(223, 103, 103, 0.4);
}

.HolesPanel_kind_db_only__6-CpO {
  background: rgba(59, 127, 212, 0.15);
  border-color: rgba(59, 127, 212, 0.4);
}

.HolesPanel_kind_partial__0zAu8 {
  background: rgba(142, 106, 203, 0.15);
  border-color: rgba(142, 106, 203, 0.4);
}

.HolesPanel_kind_s3_only__SLbld {
  background: rgba(239, 161, 44, 0.2);
  border-color: rgba(239, 161, 44, 0.5);
}

.HolesPanel_table__gid-z {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.HolesPanel_table__gid-z th {
  text-align: left;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #acacac;
  padding: 4px 8px;
  border-bottom: 1px solid #dbdbdb;
}
.HolesPanel_table__gid-z td {
  padding: 6px 8px;
  border-bottom: 1px solid #f4f5f7;
  color: #838383;
}

.HolesPanel_pager__Sw7t8 {
  display: flex;
  align-items: center;
  gap: 4px;
}

.HolesPanel_pagerBtn__EFcot {
  background: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 3px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #838383;
  font-size: 12px;
}
.HolesPanel_pagerBtn__EFcot:hover:not(:disabled) {
  background: #f4f5f7;
  border-color: #acacac;
}
.HolesPanel_pagerBtn__EFcot:disabled {
  cursor: default;
  opacity: 0.4;
}

.HolesPanel_pagerLabel__VMeek {
  font-size: 12px;
  color: #838383;
  margin: 0 5px;
  min-width: 70px;
  text-align: center;
  font-family: monospace;
}

.HolesPanel_headerActions__yb3oc {
  display: flex;
  align-items: center;
  gap: 10px;
}

.HolesPanel_exportBtn__f4h-1 {
  padding: 5px 12px;
  font-size: 12px;
  background: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 3px;
  color: #838383;
  cursor: pointer;
}
.HolesPanel_exportBtn__f4h-1:hover:not(:disabled) {
  background: #f4f5f7;
  border-color: #acacac;
}
.HolesPanel_exportBtn__f4h-1:disabled {
  cursor: default;
  opacity: 0.5;
}

.HolesPanel_suitcaseBadge__QtXOj {
  margin-left: 6px;
}`, "",{"version":3,"sources":["webpack://./src/dashboard/components/SyncMonitor/HolesPanel/HolesPanel.module.scss","webpack://./src/_common/scss/_variables.scss","webpack://./src/_common/scss/_colors.scss"],"names":[],"mappings":"AAGA;EACE,kBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SCDS;EDET,eAAA;EACA,mBCHS;EDIT,mBCLS;EDMT,gCAAA;AAFF;;AAKA;EACE,kBCGa;EDFb,gBAAA;EACA,cEZS;EFaT,SAAA;EACA,yBAAA;EACA,sBAAA;AAFF;;AAKA;EACE,gBCnBS;EDoBT,gBAAA;EACA,cEtBS;EFuBT,oBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,aAAA;EACA,eAAA;EACA,SC5BS;ED6BT,mBC7BS;AD2BX;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAFF;;AAKA;EACE,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,cE5CS;AF0CX;;AAKA;EACE,gBAAA;EACA,eAAA;EACA,gBE5CM;EF6CN,yBAAA;EACA,kBC1Dc;ED2Dd,cEpDS;AFkDX;AAIE;EACE,aAAA;EACA,kCEjEM;AF+DV;;AAMA;EACE,aAAA;EACA,eAAA;EACA,SC7DS;ED8DT,eAAA;EACA,cEjES;EFkET,kBClES;AD+DX;;AAMA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,mCAAA;AAHF;;AAMA;EACE,eAAA;EACA,eAAA;EACA,cEjFS;AF8EX;;AAMA;EACE,cErFS;EFsFT,eC9Ee;ED+Ef,cAAA;AAHF;;AAMA;EACE,aAAA;EACA,uBAAA;EACA,aC9FW;AD2Fb;;AAMA;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,SCzGS;ED0GT,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,cEnHS;AFgHX;AAKE;EACE,mBEzHO;AFsHX;AAZA;EAkBE,yBAAA;UAAA,iBAAA;EACA,sBAAA;AAHF;;AAMA;EACE,eAAA;EACA,cEhIS;EFiIT,gCAAA;AAHF;;AAMA;EACE,wBAAA;AAHF;;AAMA;EACE,+BAAA;EACA,kBAAA;EACA,gCAAA;AAHF;;AAMA;EACE,sBAAA;EACA,gBAAA;EACA,2BEzJQ;EF0JR,eAAA;AAHF;;AAMA;EACE,SAAA;AAHF;;AAMA;EACE,cE1JS;EF2JT,eAAA;AAHF;;AAMA;EACE,sBAAA;EACA,eAAA;AAHF;;AAMA;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBE5KS;EF6KT,yBAAA;EACA,mBAAA;AAHF;;AAOA;EAAgB,qCAAA;EAAuC,sCAAA;AAFvD;;AAGA;EAAgB,oCAAA;EAAsC,qCAAA;AAEtD;;AADA;EAAgB,qCAAA;EAAuC,sCAAA;AAMvD;;AALA;EAAgB,mCAAA;EAAqC,qCAAA;AAUrD;;AARA;EACE,WAAA;EACA,yBAAA;EACA,eAAA;AAWF;AATE;EACE,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,cE/LO;EFgMP,gBAAA;EACA,gCAAA;AAWJ;AARE;EACE,gBAAA;EACA,gCAAA;EACA,cEtMO;AFgNX;;AANA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AASF;;AANA;EACE,gBE5MM;EF6MN,yBAAA;EACA,kBC1Nc;ED2Nd,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cE1NS;EF2NT,eAAA;AASF;AAPE;EACE,mBEjOO;EFkOP,qBEhOO;AFyOX;AANE;EACE,eAAA;EACA,YAAA;AAQJ;;AAJA;EACE,eAAA;EACA,cE1OS;EF2OT,aAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AAOF;;AAJA;EACE,aAAA;EACA,mBAAA;EACA,SCnPS;AD0PX;;AAJA;EACE,iBAAA;EACA,eAAA;EACA,gBErPM;EFsPN,yBAAA;EACA,kBCnQc;EDoQd,cE7PS;EF8PT,eAAA;AAOF;AALE;EACE,mBEpQO;EFqQP,qBEnQO;AF0QX;AAJE;EACE,eAAA;EACA,YAAA;AAMJ;;AAFA;EACE,gBAAA;AAKF","sourcesContent":["@import '@common/scss/_variables';\n@import '@common/scss/_colors';\n\n.panel {\n  padding: $padding-l $padding-xl;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: $margin-m;\n  flex-wrap: wrap;\n  margin-bottom: $margin-m;\n  padding-bottom: $margin-s;\n  border-bottom: 1px solid $grey-100;\n}\n\n.title {\n  font-size: $h3-font-size;\n  font-weight: 600;\n  color: $grey-400;\n  margin: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.count {\n  margin-left: $margin-s;\n  font-weight: 400;\n  color: $grey-300;\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n.filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: $margin-m;\n  margin-bottom: $margin-m;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.fieldLabel {\n  font-size: 9px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: $grey-300;\n}\n\n.select {\n  padding: 5px 8px;\n  font-size: 13px;\n  background: $white;\n  border: 1px solid $grey-200;\n  border-radius: $border-radius;\n  color: $grey-400;\n\n  &:focus {\n    outline: none;\n    border-color: $primary;\n  }\n}\n\n.summary {\n  display: flex;\n  flex-wrap: wrap;\n  gap: $margin-l;\n  font-size: 12px;\n  color: $grey-400;\n  margin-bottom: $margin-s;\n}\n\n.warn {\n  margin: 0 0 $margin-s;\n  padding: 4px 10px;\n  border-radius: 4px;\n  font-size: 12px;\n  background: rgba(239, 161, 44, 0.2);\n}\n\n.hint {\n  margin: 0 0 $margin-s;\n  font-size: 11px;\n  color: $grey-300;\n}\n\n.empty {\n  color: $grey-300;\n  font-size: $base-font-size;\n  margin: $margin-m 0;\n}\n\n.loaderWrap {\n  display: flex;\n  justify-content: center;\n  padding: $padding-xl;\n}\n\n.list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  max-height: 520px;\n  overflow-y: auto;\n}\n\n.row {\n  display: flex;\n  align-items: center;\n  gap: $margin-m;\n  width: 100%;\n  padding: $padding-s $padding-m;\n  background: none;\n  border: none;\n  border-bottom: 1px solid $grey-100;\n  cursor: pointer;\n  text-align: left;\n  font-size: 13px;\n  color: $grey-400;\n\n  &:hover {\n    background: $grey-100;\n  }\n  // A div, not a button: ids inside must stay selectable (see rowSelection.js).\n  user-select: text;\n  box-sizing: border-box;\n}\n\n.chevron {\n  font-size: 10px;\n  color: $grey-300;\n  transition: transform 0.15s ease;\n}\n\n.chevronOpen {\n  transform: rotate(90deg);\n}\n\n.accordion {\n  background: rgba(0, 0, 0, 0.02);\n  padding: $padding-m $padding-l;\n  border-bottom: 1px solid $grey-100;\n}\n\n.date {\n  font-family: monospace;\n  font-weight: 600;\n  color: $primary;\n  min-width: 90px;\n}\n\n.centerName {\n  flex: 1;\n}\n\n.ext {\n  color: $grey-300;\n  font-size: 12px;\n}\n\n.mono {\n  font-family: monospace;\n  font-size: 12px;\n}\n\n.badge {\n  display: inline-block;\n  padding: 1px 8px;\n  border-radius: 10px;\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  background: $grey-100;\n  border: 1px solid $grey-200;\n  white-space: nowrap;\n}\n\n\n.kind_both    { background: rgba(223, 103, 103, 0.15); border-color: rgba(223, 103, 103, 0.4); }\n.kind_db_only { background: rgba(59, 127, 212, 0.15); border-color: rgba(59, 127, 212, 0.4); }\n.kind_partial { background: rgba(142, 106, 203, 0.15); border-color: rgba(142, 106, 203, 0.4); }\n.kind_s3_only { background: rgba(239, 161, 44, 0.2); border-color: rgba(239, 161, 44, 0.5); }\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n\n  th {\n    text-align: left;\n    font-size: 11px;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: $grey-300;\n    padding: 4px 8px;\n    border-bottom: 1px solid $grey-200;\n  }\n\n  td {\n    padding: 6px 8px;\n    border-bottom: 1px solid $grey-100;\n    color: $grey-400;\n  }\n}\n\n.pager {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.pagerBtn {\n  background: $white;\n  border: 1px solid $grey-200;\n  border-radius: $border-radius;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: $grey-400;\n  font-size: 12px;\n\n  &:hover:not(:disabled) {\n    background: $grey-100;\n    border-color: $grey-300;\n  }\n\n  &:disabled {\n    cursor: default;\n    opacity: 0.4;\n  }\n}\n\n.pagerLabel {\n  font-size: 12px;\n  color: $grey-400;\n  margin: 0 $margin-s;\n  min-width: 70px;\n  text-align: center;\n  font-family: monospace;\n}\n\n.headerActions {\n  display: flex;\n  align-items: center;\n  gap: $margin-m;\n}\n\n.exportBtn {\n  padding: 5px 12px;\n  font-size: 12px;\n  background: $white;\n  border: 1px solid $grey-200;\n  border-radius: $border-radius;\n  color: $grey-400;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    background: $grey-100;\n    border-color: $grey-300;\n  }\n\n  &:disabled {\n    cursor: default;\n    opacity: 0.5;\n  }\n}\n\n.suitcaseBadge {\n  margin-left: 6px;\n}\n\n","@import './colors';\n\n$border-radius: 3px !default;\n$border-radius-extra: 8px !default;\n$padding-s: 5px;\n$padding-m: 10px;\n$padding-l: 20px;\n$padding-xl: 30px;\n$padding-xxl: 40px;\n$margin-s: 5px;\n$margin-m: 10px;\n$margin-l: 20px;\n$margin-xl: 30px;\n$margin-xxl: 40px;\n$margin-xxxl: 50px;\n$shadow-depth: 1;\n$base-font-size: 14px !default;\n$base-line-height: 17px !default;\n$base-unit: 'em' !default;\n$base-font-family: 'Source Sans Pro', sans-serif !default;\n$h1-font-size: 2 * $base-font-size !default;\n$h2-font-size: 1.5 * $base-font-size !default;\n$h3-font-size: 1.17 * $base-font-size !default;\n$h4-font-size: 1 * $base-font-size !default;\n$h5-font-size: 0.83 * $base-font-size !default;\n$h6-font-size: 0.67 * $base-font-size !default;\n$indent-amount: 40px !default;\n$normalize-vertical-rhythm: false !default;\n$default-border: solid 1px $default-border-color;\n$navbar-z-index: 10000;\n$top-most-z-index: 100000;\n$navbar-height: 67px;\n$navbar-bg: #d9d9d9;\n$default-navbar-shadow: 0 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-statscard-shadow: 3px 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-mainfilters-shadow: inset -3px 0 3px rgb(0 0 0 / 0.1);\n","$primary: var(--primary-color);\n$secondary: var(--secondary-color);\n$accent: var(--accent-color);\n$font-primary: var(--font-primary-color);\n$font-secondary: var(--font-secondary-color);\n$font-accent: var(--font-accent-color);\n$grey-100: #f4f5f7;\n$grey-200: #dbdbdb;\n$grey-300: #acacac;\n$grey-400: #838383;\n$chart-dataset-1: #df6767;\n$chart-dataset-2: #efa12c;\n$warning: orange;\n$error: #df6767;\n$white: #fff;\n$transparent: transparent;\n\n$primary-font-color: #fff;\n$secondary-font-color: #fff;\n$accent-font-color: #fff;\n$warning-font-color: #fff;\n$error-font-color: #fff;\n$filter-bg: #fff;\n\n$bg-main: var(--background-color);\n$card-bg: #fff;\n$default-control-bg: #fff;\n$card-shadow: 3px 3px 3px -1px rgba(0, 0, 0, 0.1);\n$default-shadow-color: rgba(0, 0, 0, 0.1);\n\n$default-border-color: #acacac;\n$default-backdrop-color: rgba(0, 0, 0, 0.8);\n\n$default-navbar-color: #fff;\n\n$stats-card-bg-color: #fff;\n$stats-card-color: #000;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `HolesPanel_panel__+VZMo`,
	"header": `HolesPanel_header__oqIc-`,
	"title": `HolesPanel_title__DffEG`,
	"count": `HolesPanel_count__ktSCr`,
	"filters": `HolesPanel_filters__GYAvH`,
	"field": `HolesPanel_field__WcnQg`,
	"fieldLabel": `HolesPanel_fieldLabel__r5qpI`,
	"select": `HolesPanel_select__3EOfJ`,
	"summary": `HolesPanel_summary__-PGaR`,
	"warn": `HolesPanel_warn__aA8yx`,
	"hint": `HolesPanel_hint__xxgJd`,
	"empty": `HolesPanel_empty__ZEU8v`,
	"loaderWrap": `HolesPanel_loaderWrap__FRLxC`,
	"list": `HolesPanel_list__Vw32D`,
	"row": `HolesPanel_row__d5ul9`,
	"chevron": `HolesPanel_chevron__wthFN`,
	"chevronOpen": `HolesPanel_chevronOpen__UDGWK`,
	"accordion": `HolesPanel_accordion__e4SmD`,
	"date": `HolesPanel_date__krgmZ`,
	"centerName": `HolesPanel_centerName__61nWe`,
	"ext": `HolesPanel_ext__Q6pyC`,
	"mono": `HolesPanel_mono__pZT1n`,
	"badge": `HolesPanel_badge__PGI4L`,
	"kind_both": `HolesPanel_kind_both__Nk57l`,
	"kind_db_only": `HolesPanel_kind_db_only__6-CpO`,
	"kind_partial": `HolesPanel_kind_partial__0zAu8`,
	"kind_s3_only": `HolesPanel_kind_s3_only__SLbld`,
	"table": `HolesPanel_table__gid-z`,
	"pager": `HolesPanel_pager__Sw7t8`,
	"pagerBtn": `HolesPanel_pagerBtn__EFcot`,
	"pagerLabel": `HolesPanel_pagerLabel__VMeek`,
	"headerActions": `HolesPanel_headerActions__yb3oc`,
	"exportBtn": `HolesPanel_exportBtn__f4h-1`,
	"suitcaseBadge": `HolesPanel_suitcaseBadge__QtXOj`
};
export default ___CSS_LOADER_EXPORT___;
